export function userAgentIsBot() {
    return /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);
}